var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-button',{staticClass:"mr-4",attrs:{"color":"primary","type":"border"},on:{"click":function($event){$event.preventDefault();return _vm.backToOriginalUser($event)}}},[_vm._v("\n  Voltar ao Usuário Original\n")])}
var staticRenderFns = []

export { render, staticRenderFns }